import { SubItem } from '../../state.atoms'

export const filterPlaceholderSubItem = (subItems: SubItem[]): SubItem[] => {
  if (subItems.length === 1) return subItems

  return subItems.reduce((acc: SubItem[], subItem: SubItem, index: number) => {
    if (
      index === subItems.length - 1 &&
      subItem.title === '' &&
      subItem.rate === ''
    ) {
      return acc
    }

    return [...acc, subItem]
  }, [])
}

export const isSubItemCompleted = (subItem: SubItem): boolean => {
  return subItem.title !== '' && subItem.quantity !== '' && subItem.rate !== ''
}

export const isSubItemPartiallyCompleted = (subItem: SubItem): boolean => {
  // ignore the prefilled subItem.quantity value
  return subItem.title !== '' || subItem.rate !== ''
}
